import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { SparkObjectDataset } from 'app/model/dataset/spark.dataset';
import { TabularCopySource } from './tabular-type.copysource';
import { MAX_INT32 } from 'app/shared/shared-constants';

@Metamodel.model({
    name: 'SparkSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(SparkObjectDataset) }
})
export class SparkCopySource extends TabularCopySource {
    public static readonly BATCH_SIZE: IAttribute;
    public static readonly QUERY_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'BATCH_SIZE',
        display: stringResources.ModelName_BatchSize,
        constraint: {
            minimum: 1,
            maximum: Number.MAX_SAFE_INTEGER
        }
    })
    public batchSize?: number = 50000;

    @Metamodel.attribute({
        templatable: true,
        association: 'QUERY_TIMEOUT',
        display: stringResources.ModelName_Source_QueryTimeout_Sec,
        constraint: {
            minimum: 1,
            maximum: MAX_INT32
        }
    })
    public queryTimeout?: number = 1800;
}
